export default "__VITE_ASSET__DGA9kdKp__"